import { Link } from 'react-router-dom';

export function NotFound() {
    return (
        <div className="min-vh-100 d-flex align-items-center" style={{background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'}}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-8 col-lg-6">
                        <div className="modern-card text-center p-5">
                            <div className="mb-4">
                                <div className="d-inline-flex align-items-center justify-content-center rounded-circle mb-4"
                                     style={{
                                         width: '6rem',
                                         height: '6rem',
                                         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)'
                                     }}>
                                    <i className="bi bi-exclamation-triangle-fill text-white" style={{fontSize: '3rem'}}></i>
                                </div>
                                <h1 className="display-1 fw-bold mb-3" style={{color: '#1e293b'}}>404</h1>
                                <h2 className="h3 fw-semibold mb-3" style={{color: '#1e293b'}}>Oops! Page Not Found</h2>
                                <p className="text-muted mb-4" style={{fontSize: '1.1rem'}}>
                                    The page you're looking for doesn't exist or has been moved.
                                </p>
                            </div>

                            <div className="d-flex gap-3 justify-content-center flex-wrap">
                                <Link to="/" className="btn btn-modern btn-lg">
                                    <i className="bi bi-house-fill me-2"></i>
                                    Go Home
                                </Link>
                                <Link to="https://www.arcanescale.com/contact-us" className="btn btn-outline-modern btn-lg">
                                    <i className="bi bi-question-circle me-2"></i>
                                    Get Help
                                </Link>
                            </div>
                        </div>

                        <div className="text-center mt-4">
                            <p className="text-white-50 small mb-0">
                                <i className="bi bi-info-circle me-1"></i>
                                If you believe this is an error, please contact support
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}